<template>
  <ScatterChart :height="100" :chartdata='chartdata' :options="options" />
</template>

<script>
import ScatterChart from '@/components/charts/scatter'

export default {
  name: 'CallsTimeline',
  components: {
    ScatterChart
  },
  props: {
    period: {
      type: String
    },
    date: {
      type: String
    },
    calls: {
      type: Array
    }
  },
  data () {
    return {
      chartdata: null
    }
  },
  methods: {
    getMin: function (period, date) {
      switch (period) {
        case 'week':
          return this.$moment(date, 'YYYY-WW').startOf('isoWeek').format('YYYY-MM-DD HH:mm')
        case 'month':
          return this.$moment(this.date, 'YYYY-MM').startOf('month').format('YYYY-MM-DD HH:mm')
        default:
          break
      }
    },
    getMax: function (period, date) {
      switch (period) {
        case 'week':
          return this.$moment(date, 'YYYY-WW').endOf('isoWeek').format('YYYY-MM-DD HH:mm')
        case 'month':
          return this.$moment(this.date, 'YYYY-MM').endOf('month').format('YYYY-MM-DD HH:mm')
        default:
          break
      }
    },
    fillchartdata: function () {
      var au = []
      var uk = []
      var us = []
      for (const call of this.calls) {
        switch (call.region) {
          case 'AUS':
            au.push({x: this.$moment.unix(call.opened).utc().format('YYYY-MM-DD HH:mm'), y: 1})
            break

          case 'USA':
            us.push({x: this.$moment.unix(call.opened).utc().format('YYYY-MM-DD HH:mm'), y: 1})
            break

          case 'UK':
            uk.push({x: this.$moment.unix(call.opened).utc().format('YYYY-MM-DD HH:mm'), y: 1})
            break

          default:
            break
        }
      }

      var datasets = []

      if (au.length > 0) {
        datasets.push({
          label: 'au',
          backgroundColor: '#ef476f',
          data: au
        })
      }

      if (us.length > 0) {
        datasets.push({
          label: 'us',
          backgroundColor: '#ffd166',
          data: us
        })
      }

      if (uk.length > 0) {
        datasets.push({
          label: 'uk',
          backgroundColor: '#06d6a0',
          data: uk
        })
      }

      this.options = {
        plugins: {
          title: 'timeline'
        },
        tooltips: {
          callbacks: {
            label: function (context) {
              var dataset = datasets[context.datasetIndex]
              return dataset.data[context.index].x
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              display: false
            },
            gridLines: {
              display: false
            }
          }],
          xAxes: [{
            type: 'time',
            time: {
              unit: 'day',
              tooltipFormat: 'MMM DD'
            },
            ticks: {
              min: this.getMin(this.period, this.date),
              max: this.getMax(this.period, this.date)
            },
            gridLines: {
              display: true
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false
      }

      this.chartdata = {
        datasets: datasets
      }
    }
  },
  watch: {
    period: function () {
      this.fillchartdata()
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/CallsTimeline.vue